import {
    CONTRACTOR_BUSINESS_REQUEST,
    CONTRACTOR_BUSINESS_SUCCESS,
    CONTRACTOR_BUSINESS_FAILURE,
    CONTRACTOR_BUSINESS_SYNC_REQUEST,
    CONTRACTOR_BUSINESS_SYNC_SUCCESS,
    CONTRACTOR_BUSINESS_SYNC_FAILURE
} from '../actions';

export const CONTRACTOR_BUSINESS_INITIAL_STATE = {
    isSyncing: false,
    isFetching: false,
    error: null,
    syncError: null
};

const engineersReducers = {
    [CONTRACTOR_BUSINESS_REQUEST]: (state) => {
        return {...state, isFetching: true, error: null};
    },
    [CONTRACTOR_BUSINESS_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isFetching: false, error: null};
    },
    [CONTRACTOR_BUSINESS_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [CONTRACTOR_BUSINESS_SYNC_REQUEST]: (state) => {
        return {...state, isSyncing: true, syncError: null};
    },
    [CONTRACTOR_BUSINESS_SYNC_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isSyncing: false, syncError: null};
    },
    [CONTRACTOR_BUSINESS_SYNC_FAILURE]: (state, {error}) => {
        return {...state, isSyncing: false, syncError: error};
    }
};

export default function engineers(state = CONTRACTOR_BUSINESS_INITIAL_STATE, action) {
    let reducer = engineersReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/contractor-business.js